import axios, { AxiosRequestConfig } from 'axios'

import { unauthorize } from '../actions'
import { store } from '../store'
import { Action, Dispatch } from 'redux'

export const statusCode = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500
}

const DEFAULT_CONFIG = {
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json'
  },
  params: {},
  data: {}
}

export default class RestClient {

  config: IHashtable<any>
  dispatch: Dispatch<any>
  ignoredUnauthorizedPath: Set<string>

  constructor(config?: IHashtable<any>) {
    this.config = Object.assign({}, DEFAULT_CONFIG, config)
    // tslint:disable-next-line:no-console
    this.ignoredUnauthorizedPath = new Set<string>()
  }

  injectDispatcher(dispatch: Dispatch<any>) {
    this.dispatch = dispatch
  }

  dispatchAppAction(action: Action) {
    this.dispatch(action)
  }

  addIgnoredUnauthorizedPath(path: string) {
    this.ignoredUnauthorizedPath.add(path)
  }

  removeIgnoredUnauthorizedPath(path: string) {
    this.ignoredUnauthorizedPath.delete(path)
  }

  get(url: string, params: IHashtable<any> = {}, config: IHashtable<any> = {}) {
    return this.executeRequest(url, { ...config, params })
  }

  patch(url: string, data: IHashtable<any> = {}) {
    return this.executeRequest(url, {
      method: 'PATCH',
      data
    })
  }

  post(url: string, data: IHashtable<any> = {}, params: IHashtable<any> = {}, config: AxiosRequestConfig = {}) {
    return this.executeRequest(url, {
      method: 'POST',
      data,
      params,
      ...config
    })
  }

  delete(url: string, params: IHashtable<any> = {}) {
    return this.executeRequest(url, {
      method: 'DELETE',
      params
    })
  }

  put(url: string, data: IHashtable<any> = {}, params: IHashtable<any> = {}, config: AxiosRequestConfig = {}) {
    return this.executeRequest(url, {
      method: 'PUT',
      data,
      params,
      ...config
    })
  }

  executeRequest(url: string, config: AxiosRequestConfig): Promise<any> {
    const finalConfig = Object.assign({}, this.config, { url, ...config })

    return axios.request(finalConfig)
      .then(response => Promise.resolve(response.data))
      .catch(errorResponse => {
        const status = errorResponse.response.status
        const error = errorResponse.response.data

        if (status === statusCode.UNAUTHORIZED && !this.isIgnoredUnauthorizedPath(url)) {
          store.dispatch(unauthorize())
        }

        if (status === statusCode.INTERNAL_SERVER_ERROR) {
          window.location.href = '/errors/500'
        }

        return Promise.reject({ status, ...error })
      })
  }

  private isIgnoredUnauthorizedPath(path: string): boolean {
    if (this.ignoredUnauthorizedPath.size === 0 || !path.match(/https?:\/\//)) {
      return false
    }

    return this.ignoredUnauthorizedPath.has(new URL(path).origin)
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/RestClient.ts